namespace TabAurous.Production {
    export interface SplittingBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        CalcOnId?: number;
        AttributeId?: number;
        ItemTypeId?: number;
        KaratId?: number;
        MetalColorId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        IsCustomerItem?: boolean;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        Markup?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        Lab?: string;
        CertificateNo?: string;
    }

    export namespace SplittingBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.SplittingBOM';
        export const lookupKey = 'Production.SplittingBOM';

        export function getLookup(): Q.Lookup<SplittingBOMRow> {
            return Q.getLookup<SplittingBOMRow>('Production.SplittingBOM');
        }
        export const deletePermission = 'Production:Splitting:Delete';
        export const insertPermission = 'Production:Splitting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Splitting:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            ItemTypeId = "ItemTypeId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            IsCustomerItem = "IsCustomerItem",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            Markup = "Markup",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            Lab = "Lab",
            CertificateNo = "CertificateNo"
        }
    }
}
